import React, { useContext, useEffect } from "react";
import { RouteGuardContext } from "../../../context/RouteGuardContext";
import { useBlocker } from "react-router-dom";
import ConfirmationDialogue from "../confirmation-dialogue/ConfirmationDialogue";

const RouteGuard = () => {
  const routeGuardContext = useContext(RouteGuardContext);
  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) => routeGuardContext.getFormState() && currentLocation.pathname !== nextLocation.pathname
  );

  // Handle cancel logic
  const handleCancel = () => {
    blocker.reset();
  };

  // Handle unsaved changes logic (e.g., clear form, or navigate away)
  const handleLeave = () => {
    routeGuardContext.setFormState(false);
    blocker.proceed();
    blocker.reset();
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (routeGuardContext.getFormState()) {
        event.preventDefault();
        event.returnValue = ""; // Chrome requires this for the default dialog to show
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [routeGuardContext]);

  return (
    <ConfirmationDialogue
      isOpen={blocker.state === "blocked"}
      handleCancel={handleCancel}
      handleConfirm={handleLeave}
      confirmLabel="Proceed"
      cancelLabel="Cancel"
    />
  );
};

export default RouteGuard;
